/**
 * @param {*} id del operando
 */
export default function (id) {
  const option = {
    name: `Op${id}`,
    action: (editor) => {
      const cm = editor.codemirror;
      const selectedText = cm.getSelection();
      const text = selectedText;

      const output = `/op${id}/${text}/op${id}/`;
      cm.replaceSelection(output);
    },
    className: `zmdi zmdi-collection-item-${id}`,
    title: `Op${id}`,
  };

  return option;
}
